import { apiRequest } from '@/utils/api-request';

export const getOtp = async (email: string) => {
  const response = await apiRequest({
    url: '/user/otp/sign-in',
    method: 'POST',
    target: 'platform',
    body: {
      email: email?.toLowerCase(),
      origin: window.location.origin,
    },
  });

  if (response?.detail) {
    return { detail: response.detail || 'Failed to get OTP' };
  }

  return response;
};
